import cx from 'classnames'
import PropTypes from 'prop-types'

import AtomImage from '@s-ui/react-atom-image'
import PrimitiveVisuallyhidden from '@s-ui/react-primitive-visually-hidden'

import {
  CHECK_ELEMENT_IMAGE_CLASS_NAME,
  CHECK_ELEMENT_IMAGE_OPACITY_CLASS_NAME,
  CHECK_ELEMENT_IMAGE_WRAPPER_CLASS_NAME
} from '../../../config.js'
import {DECORATIVE_IMAGE_ALT, ELEMENT_ROLE, INPUT_ELEMENT} from './config.js'

const FilterItemBasicImage = ({id, isChecked, imageSrc, onChange}) => {
  const imageClassNames = cx(CHECK_ELEMENT_IMAGE_CLASS_NAME, isChecked && CHECK_ELEMENT_IMAGE_OPACITY_CLASS_NAME)

  return (
    <div className={CHECK_ELEMENT_IMAGE_WRAPPER_CLASS_NAME}>
      <PrimitiveVisuallyhidden as={INPUT_ELEMENT} checked={isChecked} id={id} onChange={onChange} type={ELEMENT_ROLE} />
      <AtomImage aria-hidden className={imageClassNames} src={imageSrc} alt={DECORATIVE_IMAGE_ALT} />
    </div>
  )
}

FilterItemBasicImage.displayName = 'FilterItemBasicImage'
FilterItemBasicImage.propTypes = {
  id: PropTypes.string,
  imageSrc: PropTypes.string,
  isChecked: PropTypes.bool,
  onChange: PropTypes.func
}

export default FilterItemBasicImage
